import { render, staticRenderFns } from "./Onboard.vue?vue&type=template&id=501ce008&"
import script from "./Onboard.vue?vue&type=script&lang=js&"
export * from "./Onboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports